// @flow

import { Ingredient } from './Types';

export const availableIngredients: ReadonlyArray<Ingredient> = [
  // Hard liquors
  'gin',
  'tequila',
  'vodka',
  'whiskey',
  'rum',
  'vanilla vodka',

  // Liqueurs /wines
  'sweet vermouth',
  'campari',
  'bitters',
  'orange bitters',
  'chambord',
  'champagne',
  'elderflower liqueur',
  'Cointreau',
  'dry vermouth',
  'white wine',
  'red wine',
  'rose wine',
  'coffee liqueur',
  'aperol',
  'St. Germain',
  'pomegranate liqueur',
  'ginger liqueur',
  'creme de violette',
  'creme de menthe',
  'amaretto',
  // 'cognac',
  //   'lillet blanc',
  //   'Lillet Blanc',
  //   'Irish cream liqueur',
  //   'amarula',

  // Mixers / Non-alcoholic
  'sugar',
  'orgeat',
  'milk',
  'water',
  'grenadine',
  'club soda',
  'simple syrup',
  'lemon',
  'lime',
  'egg white',
  // 'mint',
  // 'cranberry juice',
  'orange juice',
  'ginger beer',
  // 'cola',
  // 'maraschino',
  'coffee',
  // 'tang',
  'fever-tree elderflower tonic',
  'fever-tree tonic',
  // 'fever-tree blood orange soda',
  // 'fever-tree lemonade',
  'tea',
  'cocoa',
  'olipop',
  'poppi',
  'izze',
  'athletic',
  'humm',
];
